<template>
  <div class="commentsItemBox">
    <ul class="commentsUl_flat" v-if="comment.template!='waterfall'">
      <template v-for="item in new_comments_list">
        <li
          class="commentsItem"
          v-if="item.comment_approved&&item.status=='publish'"
          :key="item.comment_ID"
        >
          <div class="personInfoBox">
            <div class="personPhoto iconfont">&#xe678;</div>
            <div class="personInfo">
              <span class="name">{{item.name}}</span>
              <p class="country_time">
                <span class="country" v-if="comment.comment_country=='yes'&&item.country">
                  <country-flag :country="item.country" size="big" />
                  {{item.country}}
                </span>
                <span class="spot" v-if="comment.comment_country=='yes'&&item.country">·</span>
                <span class="date" v-if="comment.comment_time=='yes'">{{item.comment_date}}</span>
              </p>
            </div>
          </div>
          <div class="star">
            <v-commentsstar :disabled="true" :average_rating="item.rating" font_size="18"></v-commentsstar>
          </div>
          <p class="comment_detail">{{item.content}}</p>
          <div class="comment_photo" v-if="item.gallery.length">
            <img
              v-for="(subitem,subindex) in item.gallery "
              :key="subitem.ID"
              :src="subitem.thumbnail"
              @click="showBigImg(item.gallery,subindex)"
              alt
            />
          </div>
          <p
            class="helpful_num"
            v-if="comment.comment_account=='yes'&& item.like_account>0"
          >{{item.like_account}} {{$t('comment.people_found_this_helpful')}}</p>
          <span class="helpful" v-show="item.help_show" @click="comment_helpful(item)">{{$t('comment.helpful')}}</span>
          <span class="helpful_tips" v-show="!item.help_show">{{$t('comment.thank_you_for_your_feedback')}}</span>
          <span
            class="report"
            v-show="item.abuse_show"
            @click="click_abuse(item)"
          >{{$t('comment.report_as_inappropriate')}}</span>
          <span class="report" v-show="!item.abuse_show">{{$t('comment.this_review_has_been_reported')}}</span>
        </li>
      </template>
    </ul>
    <ul class="commentsUl_waterfall" v-if="comment.template=='waterfall'">
      <template v-for="item in new_comments_list">
        <li v-if="item.comment_approved&& item.status=='publish'" :key="item.comment_ID">
          <div class="waterfall_box">
            <div class="waterfall_picture_num" v-if="item.gallery.length>1">{{item.gallery.length}}</div>
            <div class="waterfall_commentsphoto" v-if="item.gallery.length">
              <img
                @click="showBigImg(item.gallery,0)"
                :data-srcset="item.gallery[0].srcset"
                :srcset="item.gallery[0].srcset"
                data-sizes="auto"
                @error.once="imageFailure"
                class="lazyload"
                alt
              />
            </div>
            <div class="waterfall_person_photo iconfont">&#xe678;</div>
            <div class="waterfall_main">
              <div class="person_info">
                <span class="name">{{item.name}}</span>
                <p class="country_time">
                  <span class="country" v-if="comment.comment_country=='yes'&&item.country">
                    <country-flag :country="item.country" size="big" />
                    {{item.country}}
                  </span>
                  <span class="spot" v-if="comment.comment_country=='yes'&&item.country">·</span>
                  <span class="date" v-if="comment.comment_time=='yes'">{{item.comment_date}}</span>
                </p>
                <div class="star">
                  <v-commentsstar :disabled="true" :average_rating="item.rating" font_size="18"></v-commentsstar>
                </div>
                <p class="detail">{{item.content}}</p>
                <p
                  class="helpful_num"
                  v-if="comment.comment_account=='yes'&& item.like_account>0"
                >{{item.like_account=='1'?'one':item.like_account}} people found this helpful</p>
                <span class="help" v-show="item.help_show" @click="comment_helpful(item)">{{$t('comment.helpful')}}</span>
                <span class="help_tips" v-show="!item.help_show">{{$t('comment.thank_you_for_your_feedback')}}</span>
                <span
                  class="report"
                  v-show="item.abuse_show"
                  @click="click_abuse(item)"
                >{{$t('comment.report_as_inappropriate')}}</span>
                <span class="report" v-show="!item.abuse_show">{{$t('comment.this_review_has_been_reported')}}</span>
              </div>
            </div>
          </div>
        </li>
      </template>
    </ul>
    <div class="pagination" v-if="comments_list.length>comment.count-0">
      <el-pagination
        layout="prev, pager, next"
        @current-change="changepage"
        :total="comments_list.length"
        :page-size="comment.count-0"
        :pager-count="7"
      ></el-pagination>
    </div>
    <el-dialog :title="$t('comment.warning')" :visible.sync="dialogVisible">
      <span>
        <i class="iconfont" style="color:red;">&#xe601;</i> {{$t('comment.inappropriate')}}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" style="background:white;border: 1px solid #DCDFE6;color: #606266;">{{$t('comment.cancel')}}</el-button>
        <el-button type="primary" class="main_button" @click="comment_abuse" :loading="loading">{{$t('comment.confirm')}}</el-button>
      </span>
    </el-dialog>
    <v-product-big-img
      :bigImgOnOff="bigImgOnOff"
      @hideBigImg="hideBigImg"
      :bigImgGallery="bigImgGallery"
      :bigImgGalleryIndex="bigImgGalleryIndex"
    ></v-product-big-img>
  </div>
</template>
<script>
import vCommentsstar from "./commentsstar";
import CountryFlag from "vue-country-flag";
import vProductBigImg from "./productBigImg";
export default {
  props: ["comment", "comments", "product_id"],
  data() {
    return {
      show: true,
      comments_list: [],
      new_comments_list: [],
      current_page: 1,
      dialogVisible: false,
      loading: false,
      comment_item: {}, //点击举报的时候用的单挑评论
      bigImgOnOff: false,
      bigImgGallery: [],
      bigImgGalleryIndex: 0
    };
  },
  methods: {
    hideBigImg() {
      this.bigImgOnOff = false;
      this.$("html,body").css({ overflowY: "auto" });
    },
    showBigImg(gallery, index) {
      this.$("html,body").css({ overflowY: "hidden" });
      this.bigImgOnOff = true;
      this.bigImgGallery = gallery;
      this.bigImgGalleryIndex = index;
    },
    click_abuse(item) {
      this.dialogVisible = true;
      this.comment_item = item;
    },
    async comment_abuse() {
      this.loading = true;
      if (this.comment_item.add_comment) {
        this.comment_item.abuse_show = false;
        this.dialogVisible = false;
        this.loading = false;
        return;
      }
      try {
        let res = await this.$axios.post(
          `/api/store/comments/${this.comment_item.comment_ID}/abuse`,
          {
            ip: this.$store.state.ipinfo.ip
          }
        );
        if (res.status == 200) {
          this.comment_item.abuse_show = false;
          this.$forceUpdate();
        }
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
      this.dialogVisible = false;
      this.loading = false;
    },
    async comment_helpful(e) {
      if (e.add_comment) {
        e.help_show = false;
        return;
      }
      try {
        let res = await this.$axios.post(
          `/api/store/comments/${e.comment_ID}/thumbup`,
          {
            ip: this.$store.state.ipinfo.ip
          }
        );
        console.log(res);
        if (res.status == 200) {
          e.help_show = false;
          this.$forceUpdate();
        }
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    changepage(e) {
      console.log(e);
      this.current_page = e;
      this.$("html, body").animate(
        {
          scrollTop: this.$("#comments_title").offset().top
        },
        500
      );
      this.new_comments_list = this.comments_list.slice(
        (e - 1) * (this.comment.count - 0),
        e * (this.comment.count - 0)
      );
    }
  },
  beforeMount() {
    console.log("comment", this.comment);
    this.comments.sort(function (a,b) {
      return new Date(b.comment_date).getTime() - new Date(a.comment_date).getTime() ;
    })
    this.comments.forEach((item, index) => {
      if (item.comment_approved && item.status == "publish") {
        let timestamp = new Date(item.top_date).getTime();
        item.help_show = true;
        item.abuse_show = true;
        if (this.comments_list.length == 0) {
          this.comments_list.push(item);
        } else {
          if (timestamp > new Date(this.comments_list[0].top_date).getTime()) {
            this.comments_list.unshift(item);
          } else {
            this.comments_list.push(item);
          }
        }
      }
    });
    console.log("this.comments_list", this.comments_list);
    this.new_comments_list = this.comments_list.slice(
      0,
      this.comment.count - 0
    );
    console.log("this.new_comments_list", this.new_comments_list);
  },
  mounted() {},
  components: {
    vCommentsstar,
    CountryFlag,
    vProductBigImg
  },
  watch: {
    "$store.state.new_comment"() {
      this.comments_list.unshift(this.$store.state.new_comment);
      if (this.current_page == 1) {
        this.new_comments_list = this.comments_list.slice(0, 8);
      }
    }
  }
};
</script>
<style  lang='scss'>
.commentsItemBox {
  .el-dialog__wrapper {
    .el-dialog {
      max-width: 959px;
      width: 100%;
    }
  }

  .pagination {
    display: felx;
    justify-content: center;
  }
  .commentsUl_flat {
    padding: 0;
    .commentsItem {
      color: #666;
      margin: 0;
      -webkit-tap-highlight-color: transparent;
      outline: 0;
      list-style: none;
      position: relative;
      padding: 20px 0 16px 60px;
      .personInfoBox {
        .personPhoto {
          margin: 0;
          padding: 0;
          -webkit-tap-highlight-color: transparent;
          margin-top: 0;
          position: absolute;
          width: 40px;
          height: 40px;
          left: 0;
          top: 20px;
          font-size: 30px;
          border-radius: 50%;
          color: white;
          overflow: hidden;
          background-color: #999;
          line-height: 52px;
          text-align: center;
        }
        .personInfo {
          .name {
            margin: 0;
            padding: 0;
            -webkit-tap-highlight-color: transparent;
            font-family: ArapeyRegular !important;
            font-size: 14px;
            color: #666;
            word-break: break-all;
            margin-bottom: 6px;
            display: inline-block;
            position: relative;
            height: 15px;
            line-height: 15px;
          }
          .country_time {
            margin: 0;
            padding: 0;
            font-size: 12px;
            color: #999;
            .country {
              .flag {
                zoom: 0.25;
                margin-right: 8px;
              }
            }
          }
        }
      }
      .star {
        margin: 8px 0;
      }
      .comment_detail {
        font-size: 16px;
        padding-bottom: 8px;
        margin: 0;
        color: #333;
      }
      .comment_photo {
        img {
          padding: 0;
          -webkit-tap-highlight-color: transparent;
          width: 48px;
          height: 48px;
          display: inline-block;
          background: #f2f2f2;
          margin: 5px;
          box-sizing: border-box;
          cursor: zoom-in;
          object-fit: cover;
        }
      }
      .helpful_num {
        font-size: 14px;
        color: #999;
        margin: 0;
        padding-bottom: 14px;
      }
      .helpful {
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: transparent;
        width: 68px;
        height: 28px;
        background: #fff;
        display: inline-block;
        line-height: 28px;
        text-align: center;
        border: 1px solid #ddd;
        border-radius: 2px;
        cursor: pointer;
        color: #333;
        font-size: 14px;
      }
      .helpful_tips {
        list-style: none;
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: transparent;
        color: #008100;
        font-size: 14px;
        display: inline;
      }
      .report {
        margin: 0;
        padding: 0;
        white-space: normal;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        color: #666;
        font-size: 14px;
        margin-top: 0;
        line-height: 24px;
        width: 100%;
        border-left: 1px solid #ddd;
        padding-left: 10px;
        margin-left: 10px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .commentsUl_waterfall {
    margin: 0;
    padding: 0;
    column-count: 4;
    column-gap: 0;
    li {
      margin: 0;
      -webkit-tap-highlight-color: transparent;
      outline: 0;
      list-style: none;
      box-sizing: border-box;
      break-inside: avoid;
      padding: 10px;
      padding-top: 20px;
      .waterfall_box {
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: transparent;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-bottom: 30px;
        text-align: center;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        .waterfall_picture_num {
          text-align: center;
          margin: 0;
          -webkit-tap-highlight-color: transparent;
          position: absolute;
          right: 10px;
          top: 10px;
          background: rgba(0, 0, 0, 0.35);
          color: rgba(255, 255, 255, 0.9);
          padding: 0 15px;
          border-radius: 10px;
        }
        .waterfall_commentsphoto {
          text-align: center;
          margin: 0;
          padding: 0;
          -webkit-tap-highlight-color: transparent;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          img {
            margin: 0;
            padding: 0;
            -webkit-tap-highlight-color: transparent;
            max-width: 100%;
            height: auto;
            opacity: 1;
          }
        }
        .waterfall_person_photo {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          overflow: hidden;
          margin: -20px auto 0;
          font-size: 33px;
          line-height: 58px;
          background-color: #999;
          color: white;
        }
        .waterfall_main {
          padding: 4px 14px;
          box-sizing: border-box;
          width: 100%;
          .person_info {
            .name {
              text-align: center;
              margin: 0;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              font-size: 14px;
              color: #666;
              display: inline-block;
              vertical-align: middle;
              &::after {
                color: #bae637;
                font-family: iconfont !important;
                content: "\e63b";
                font-style: normal;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                font-size: 18px;
                vertical-align: middle;
              }
            }
            .country_time {
              margin: 0;
              .country {
                .flag {
                  zoom: 0.25;
                  margin-right: 8px;
                }
              }
              .date {
                text-align: center;
                margin: 0;
                padding: 0;
                -webkit-tap-highlight-color: transparent;
                font-size: 12px;
                color: #999;
              }
            }
            .star {
              margin-bottom: 8px;
            }
            .detail {
              font-size: 18px !important;
              text-align: center;
              -webkit-tap-highlight-color: transparent;
              margin: 0;
              padding: 12px 0 8px;
              line-height: 24px;
              word-break: break-word;
              color: #333;
            }
            .helpful_num {
              text-align: center;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              margin: 12px 0;
              font-size: 12px;
              color: #999;
              margin-top: 0;
            }
            .help {
              margin: 0;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              width: 68px;
              height: 28px;
              background: #fff;
              display: inline-block;
              line-height: 28px;
              text-align: center;
              border: 1px solid #ddd;
              border-radius: 2px;
              cursor: pointer;
              color: #333;
              font-size: 14px;
            }
            .help_tips {
              text-align: center;
              margin: 0;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              color: #008100;
              font-size: 14px;
              display: inline;
              &::before {
                content: "\e62a";
                font-size: 14px;
                font-family: iconfont !important;
                font-style: normal;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                margin-right: 5px;
              }
            }
            .report {
              margin: 0;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              margin-top: 10px;
              cursor: pointer;
              font-size: 12px;
              color: #666;
              text-align: center;
              display: block;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and(max-width: 575px) {
  .commentsItemBox {
    .commentsUl_flat{
      .commentsItem{
        padding: 8px 0 20px;
        .personInfoBox{
          .personPhoto{
            margin-right: 10px;
            position: unset;
          }
          .personPhoto,.personInfo{
            display: inline-block;
          }
        }
        .report{
          margin-left: 5px;
          padding-left:5px ;
          font-size: 12px;
        }
      }
    }
    .commentsUl_waterfall {
      column-count: 1;
    }
  }
}
</style>